// extracted by mini-css-extract-plugin
export default {"Container":"ReassignTicket_Container__HBglY","HeaderButton":"ReassignTicket_HeaderButton__BpXEJ","CustomerDetails":"ReassignTicket_CustomerDetails__kUIvE"};